import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Steps, Breadcrumb } from 'antd';

const Step = Steps.Step;

class PageCaption extends React.Component {
  render() {
    const {
      mode,
      stepsArray,
      currentStep,
      mainCaption,
      breadCrumbs,
    } = this.props;
    return (
      <div id="captionRow">
        <div className="headerRowContainer">
          <div id="headerNavBar">
            {mode === 'steps' && (
              <div className="pageCaption">
                <Steps current={currentStep}>
                  {stepsArray.map(item => (
                    <Step
                      key={item.title}
                      title={item.title}
                      description={item.description}
                    />
                  ))}
                </Steps>
                <div className="aHeight-2" />
                <h1 className="captionHeading">{mainCaption}</h1>
                <div className="aHeight-2" />
              </div>
            )}

            {mode !== 'steps' && (
              <div className="pageCaption">
                <div className="topBreadcrumbs">
                  <Breadcrumb>
                    {breadCrumbs.map((elem, i) =>
                      i === breadCrumbs.length - 1 ? (
                        // Если это последний элемент пути, не делаем его ссылкой
                        <Breadcrumb.Item key="">
                          {elem.breadcrumbName}
                        </Breadcrumb.Item>
                      ) : (
                        <Breadcrumb.Item key={elem.path}>
                          <Link to={elem.path}>{elem.breadcrumbName}</Link>
                        </Breadcrumb.Item>
                      )
                    )}
                  </Breadcrumb>
                  <div className="aHeight-2" />
                  <h1 className="captionHeading">{mainCaption}</h1>
                  <div className="aHeight-2" />
                </div>

                <div className="top-btn-area">
                  <div className="aHeight-2" />
                  {/*<BtnFeedback />*/}
                  <div className="aHeight-2" />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  mode: state.Interface.elements.pageCaption.captionType,
  stepsArray: state.Interface.elements.pageCaption.steps,
  currentStep: state.Interface.elements.pageCaption.currentStep,
  mainCaption: state.Interface.elements.pageCaption.mainCaption,
  breadCrumbs: state.Interface.elements.pageCaption.breadCrumbs,
}))(PageCaption);
